export { default as goodsInfoService } from './goods-info-service'
